import Vue from 'vue';

export const mutationTypes = {
  getIfaceStart: '[roadmap-manual] get iface start',
  getIfaceSuccess: '[roadmap-manual] get iface success',
  getIfaceFailure: '[roadmap-manual] get iface failure',

  getListStart: '[roadmap-manual] get list start',
  getListSuccess: '[roadmap-manual] get list success',
  getListFailure: '[roadmap-manual] get list failure',
  resetList: '[roadmap-manual] reset list',

  setListFilters: '[roadmap-manual] set list filters',
  resetListFilters: '[roadmap-manual] reset list filters',

  getTasksStatStart: '[roadmap-manual] get tasks stat start',
  getTasksStatSuccess: '[roadmap-manual] get tasks stat success',
  getTasksStatFailure: '[roadmap-manual] get tasks stat failure',

  createRoadmapStart: '[roadmap-manual] create roadmap start',
  createRoadmapSuccess: '[roadmap-manual] create roadmap success',
  createRoadmapFailure: '[roadmap-manual] create roadmap failure',

  createGroupRoadmapsStart: '[roadmap-manual] create group roadmaps start',
  createGroupRoadmapsSuccess: '[roadmap-manual] create group roadmaps success',
  createGroupRoadmapsFailure: '[roadmap-manual] create group roadmaps failure',

  proposeRoadmapStart: '[roadmap-manual] propose roadmap start',
  proposeRoadmapSuccess: '[roadmap-manual] propose roadmap success',
  proposeRoadmapFailure: '[roadmap-manual] propose roadmap failure',

  getProposeAvailabilityStart: '[roadmap-manual] get propose availability start',
  getProposeAvailabilitySuccess: '[roadmap-manual] get propose availability success',
  getProposeAvailabilityFailure: '[roadmap-manual] get propose availability failure',

  getDirectSupervisorsStart: '[roadmap-manual] get direct supervisors start',
  getDirectSupervisorsSuccess: '[roadmap-manual] get direct supervisors success',
  getDirectSupervisorsFailure: '[roadmap-manual] get direct supervisors failure',

  clearHeader: '[roadmap-manual] clear header',
  getHeaderStart: '[roadmap-manual] get header start',
  getHeaderSuccess: '[roadmap-manual] get header success',
  getHeaderFailure: '[roadmap-manual] get header failure',

  updateHeaderStart: '[roadmap-manual] update header start',
  updateHeaderSuccess: '[roadmap-manual] update header success',
  updateHeaderFailure: '[roadmap-manual] update header failure',

  deleteRoadmapStart: '[roadmap-manual] delete roadmap start',
  deleteRoadmapSuccess: '[roadmap-manual] delete roadmap success',
  deleteRoadmapFailure: '[roadmap-manual] delete roadmap failure',

  changeStatusStart: '[roadmap-manual] change status start',
  changeStatusSuccess: '[roadmap-manual] change status success',
  changeStatusFailure: '[roadmap-manual] change status failure',

  getDecisionsStart: '[roadmap-manual] get decisions start',
  getDecisionsSuccess: '[roadmap-manual] get decisions success',
  getDecisionsFailure: '[roadmap-manual] get decisions failure',

  getCommonMaterialsStart: '[roadmap-manual] get common materials start',
  getCommonMaterialsSuccess: '[roadmap-manual] get common materials success',
  getCommonMaterialsFailure: '[roadmap-manual] get common materials failure',

  getBlockMaterialsStart: '[roadmap-manual] get block materials start',
  getBlockMaterialsSuccess: '[roadmap-manual] get block materials success',
  getBlockMaterialsFailure: '[roadmap-manual] get block materials failure',

  getSkillsStart: '[roadmap-manual] get skills start',
  getSkillsSuccess: '[roadmap-manual] get skills success',
  getSkillsFailure: '[roadmap-manual] get skills failure',

  addMaterialsStart: '[roadmap-manual] add materials start',
  addMaterialsSuccess: '[roadmap-manual] add materials success',
  addMaterialsFailure: '[roadmap-manual] add materials failure',

  deleteMaterialsStart: '[roadmap-manual] delete materials start',
  deleteMaterialsSuccess: '[roadmap-manual] delete materials success',
  deleteMaterialsFailure: '[roadmap-manual] delete materials failure',

  updateMaterialStart: '[roadmap-manual] update material start',
  updateMaterialSuccess: '[roadmap-manual] update material success',
  updateMaterialFailure: '[roadmap-manual] update material failure',

  changeMaterialStatusStart: '[roadmap-manual] change material status start',
  changeMaterialStatusSuccess: '[roadmap-manual] change material status success',
  changeMaterialStatusFailure: '[roadmap-manual] change material status failure',

  saveMaterialResultStart: '[roadmap-manual] save material result start',
  saveMaterialResultSuccess: '[roadmap-manual] save material result success',
  saveMaterialResultFailure: '[roadmap-manual] save material result failure',

  getMaterialCommentsStart: '[roadmap-manual] get material comments start',
  getMaterialCommentsSuccess: '[roadmap-manual] get material comments success',
  getMaterialCommentsFailure: '[roadmap-manual] get material comments failure',

  addMaterialCommentStart: '[roadmap-manual] add material comment start',
  addMaterialCommentSuccess: '[roadmap-manual] add material comment success',
  addMaterialCommentFailure: '[roadmap-manual] add material comment failure',

  getSupervisedStart: '[roadmap-manual] get supervised start',
  getSupervisedSuccess: '[roadmap-manual] get supervised success',
  getSupervisedFailure: '[roadmap-manual] get supervised failure',
  resetSupervisedList: '[roadmap-manual] reset supervised list',

  setSupervisedFilters: '[roadmap-manual] set supervised filters',
  resetSupervisedFilters: '[roadmap-manual] reset supervised filters',

  getSupervisedBadgeStart: '[roadmap-manual] get supervised badge start',
  getSupervisedBadgeSuccess: '[roadmap-manual] get supervised badge success',
  getSupervisedBadgeFailure: '[roadmap-manual] get supervised badge failure',
};

const mutations = {
  [mutationTypes.getIfaceStart](state) {
    state.isLoadingIface = true;
    state.errors = null;
  },
  [mutationTypes.getIfaceSuccess](state, payload) {
    state.isLoadingIface = false;
    state.iface = payload;
  },
  [mutationTypes.getIfaceFailure](state, payload) {
    state.isLoadingIface = false;
    state.errors = payload;
  },

  [mutationTypes.getListStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getListSuccess](state, {rows = [], stat, offset = 0}) {
    state.isLoading = false;
    state.listRows = offset !== 0 ? state.listRows.concat(rows) : rows;
    state.listStat = stat;
  },
  [mutationTypes.getListFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.resetList](state) {
    state.listRows = [];
    state.listStat = null;
  },

  [mutationTypes.setListFilters](state, {key, value}) {
    const listFilters = {...state.listFilters};
    listFilters[key] = value;
    Vue.set(state, 'listFilters', listFilters);
  },

  [mutationTypes.resetListFilters](state) {
    const listFilters = {
      users: [],
      teamIds: [],
      teamGroupIds: [],
      goalTypeCodes: [],
      reasonCodes: [],
      sourceCodes: [],
      specCodes: [],
      skillType: null,
      statuses: [],
      period: null,
      mentors: [],
      hasOverdue: null,
    };
    Vue.set(state, 'listFilters', listFilters);
  },

  [mutationTypes.getTasksStatStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.tasksStat = null;
  },
  [mutationTypes.getTasksStatSuccess](state, payload) {
    state.isLoading = false;
    state.tasksStat = payload;
  },
  [mutationTypes.getTasksStatFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.createRoadmapStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.createRoadmapSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.createRoadmapFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.createGroupRoadmapsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.createGroupRoadmapsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.createGroupRoadmapsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.proposeRoadmapStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.proposeRoadmapSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.proposeRoadmapFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getProposeAvailabilityStart](state) {
    state.isLoading = true;
    state.proposeAvailability = {};
    state.errors = null;
  },
  [mutationTypes.getProposeAvailabilitySuccess](state, payload) {
    state.isLoading = false;
    state.proposeAvailability = payload;
  },
  [mutationTypes.getProposeAvailabilityFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getDirectSupervisorsStart](state) {
    state.isLoadingDirectSupervisors = true;
    state.directSupervisors = [];
    state.errors = null;
  },
  [mutationTypes.getDirectSupervisorsSuccess](state, payload) {
    state.isLoadingDirectSupervisors = false;
    state.directSupervisors = payload;
  },
  [mutationTypes.getDirectSupervisorsFailure](state, payload) {
    state.isLoadingDirectSupervisors = false;
    state.errors = payload;
  },

  [mutationTypes.clearHeader](state) {
    state.header = null;
  },

  [mutationTypes.getHeaderStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getHeaderSuccess](state, payload) {
    state.isLoading = false;
    state.header = payload;
  },
  [mutationTypes.getHeaderFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.updateHeaderStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.updateHeaderSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.updateHeaderFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.deleteRoadmapStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.deleteRoadmapSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.deleteRoadmapFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.changeStatusStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.changeStatusSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.changeStatusFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getDecisionsStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getDecisionsSuccess](state, payload) {
    state.isLoading = false;
    state.decisions = payload;
  },
  [mutationTypes.getDecisionsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getCommonMaterialsStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getCommonMaterialsSuccess](state, payload) {
    state.isLoading = false;
    state.commonMaterials = payload;
  },
  [mutationTypes.getCommonMaterialsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getBlockMaterialsStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getBlockMaterialsSuccess](state, payload) {
    state.isLoading = false;
    state.blockMaterials = payload;
  },
  [mutationTypes.getBlockMaterialsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.getSkillsStart](state) {
    state.isLoading = true;
    state.errors = null;
    state.skills = [];
  },
  [mutationTypes.getSkillsSuccess](state, payload) {
    state.isLoading = false;
    state.skills = payload;
  },
  [mutationTypes.getSkillsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.addMaterialsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.addMaterialsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.addMaterialsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.deleteMaterialsStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.deleteMaterialsSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.deleteMaterialsFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.updateMaterialStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.updateMaterialSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.updateMaterialFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.changeMaterialStatusStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.changeMaterialStatusSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.changeMaterialStatusFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.saveMaterialResultStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.saveMaterialResultSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.saveMaterialResultFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getMaterialCommentsStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getMaterialCommentsSuccess](state, payload) {
    state.isLoading = false;
    state.materialComments = payload;
  },
  [mutationTypes.getMaterialCommentsFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.addMaterialCommentStart](state) {
    state.isSubmitting = true;
    state.validationErrors = null;
  },
  [mutationTypes.addMaterialCommentSuccess](state) {
    state.isSubmitting = false;
  },
  [mutationTypes.addMaterialCommentFailure](state, payload) {
    state.isSubmitting = false;
    state.validationErrors = payload;
  },

  [mutationTypes.getSupervisedStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getSupervisedSuccess](state, {rows = [], offset = 0}) {
    state.isLoading = false;
    state.supervisedRows = offset !== 0 ? state.supervisedRows.concat(rows) : rows;
  },
  [mutationTypes.getSupervisedFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },

  [mutationTypes.resetSupervisedList](state) {
    state.supervisedRows = [];
  },

  [mutationTypes.setSupervisedFilters](state, {key, value}) {
    const supervisedFilters = {...state.supervisedFilters};
    supervisedFilters[key] = value;
    Vue.set(state, 'supervisedFilters', supervisedFilters);
  },

  [mutationTypes.resetSupervisedFilters](state) {
    const supervisedFilters = {
      users: [],
      statuses: [],
      roles: [],
      employeeName: '',
      period: null,
      waitingDecision: null,
    };
    Vue.set(state, 'supervisedFilters', supervisedFilters);
  },

  [mutationTypes.getSupervisedBadgeStart](state) {
    state.isLoading = true;
    state.errors = null;
  },
  [mutationTypes.getSupervisedBadgeSuccess](state, payload) {
    state.isLoading = false;
    state.supervisedBadge = payload;
  },
  [mutationTypes.getSupervisedBadgeFailure](state, payload) {
    state.isLoading = false;
    state.errors = payload;
  },
};

export default mutations;
